import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbButtonGroupModule,
  NbButtonModule, NbCalendarModule, NbCalendarRangeModule, NbCardModule,
  NbCheckboxModule, NbFormFieldModule, NbIconModule,
  NbInputModule, NbLayoutModule, NbPopoverModule,
  NbRadioModule,
  NbSpinnerModule,
  NbToggleModule
} from '@nebular/theme';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedInputValidatorComponent } from './components/shared-input-validator/shared-input-validator.component';
import { SharedInputValidatorItemComponent } from './components/shared-input-validator/shared-input-validator-item/shared-input-validator-item.component';
import { SharedNotFoundPageComponent } from './components/shared-not-found-page/shared-not-found-page.component';
import { CommonTranslateModule } from '../common-modules/common-translate/common-translate.module';
import { SharedInputPhoneNumberComponent } from './components/shared-input-phone-number/shared-input-phone-number.component';
import { InternationalPhoneNumber2Module } from 'ngx-international-phone-number2';
import { GenericValidationModalComponent } from './components/generic-validation-modal/generic-validation-modal.component';
import {VibrateDirective} from "./directives/vibrate.directive";
import { DateFilterButtonComponent } from './components/date-filter-button/date-filter-button.component';
import { DateFilterComponent } from './components/date-filter-button/date-filter/date-filter.component';
import {PipesModule} from "./pipes/pipes.module";
import { SharedTrackingProgressBarComponent } from './components/shared-tracking-progress-bar/shared-tracking-progress-bar.component';
import { BasicHelperIconComponent } from './components/basic-helper-icon/basic-helper-icon.component';


@NgModule({
  declarations: [
    SharedInputValidatorComponent,
    SharedInputValidatorItemComponent,
    SharedNotFoundPageComponent,
    SharedInputPhoneNumberComponent,
    GenericValidationModalComponent,
    VibrateDirective,
    DateFilterButtonComponent,
    DateFilterComponent,
    SharedTrackingProgressBarComponent,
    BasicHelperIconComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbInputModule,
    NbCheckboxModule,
    NbSpinnerModule,
    NbToggleModule,
    NbButtonModule,
    NbRadioModule,
    CommonTranslateModule,
    InternationalPhoneNumber2Module,
    NbLayoutModule,
    NbCardModule,
    NbPopoverModule,
    NbButtonGroupModule,
    PipesModule,
    NbCalendarRangeModule,
    NbCalendarModule,
    NbFormFieldModule,
    NbIconModule,
  ],
  exports: [
    NbInputModule,
    NbCheckboxModule,
    ReactiveFormsModule,
    SharedInputValidatorComponent,
    SharedInputValidatorItemComponent,
    NbSpinnerModule,
    NbToggleModule,
    SharedNotFoundPageComponent,
    NbButtonModule,
    NbRadioModule,
    SharedInputPhoneNumberComponent,
    VibrateDirective,
    DateFilterButtonComponent,
    SharedTrackingProgressBarComponent,
    BasicHelperIconComponent
  ]
})
export class SharedModule {
}
